import { render, staticRenderFns } from "./PaytenestidetailReport.vue?vue&type=template&id=67444a85&scoped=true"
import script from "./PaytenestidetailReport.vue?vue&type=script&lang=js"
export * from "./PaytenestidetailReport.vue?vue&type=script&lang=js"
import style0 from "./PaytenestidetailReport.vue?vue&type=style&index=0&id=67444a85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67444a85",
  null
  
)

export default component.exports